import type {
  JourneyFormLabels,
  JourneyPlanningLabels,
  JourneyTypeFormLabels,
} from '@wundo/ui';

/* The console's copy for the shared journey components; the app passes its own. */

export const JOURNEY_LOCALE = 'en-GB';

export const JOURNEY_TYPE_FORM_LABELS: JourneyTypeFormLabels = {
  detailsTitle: 'Journey type',
  name: 'Name',
  goal: 'Goal',
  goalDescription: 'Shown on top of every journey of this type.',
  timingTitle: 'Reminders',
  marginDays: 'Margin (days)',
  marginDaysDescription: 'How long after the target date a step is still on time.',
  preWarningDays: 'Pre-warning (days)',
  preWarningDaysDescription: 'How long before the deadline the first reminder goes out.',
  repeatIntervalDays: 'Repeat interval (days)',
  maxRepeats: 'Maximum repeats',
  stepsTitle: 'Steps',
  stepCountLocked:
    'Journeys follow this type: steps can be edited and reordered, not added or removed.',
  step: (position) => `Step ${position}`,
  stepTitle: 'Title',
  stepOffset: 'After the start date',
  stepOffsetUnit: 'Unit',
  offsetUnits: { days: 'days', weeks: 'weeks', months: 'months' },
  stepGoal: 'Goal',
  stepTemplate: 'Conversation type',
  stepTemplatePlaceholder: 'Choose a conversation type',
  addStep: 'Add step',
  moveStepUp: (position) => `Move step ${position} up`,
  moveStepDown: (position) => `Move step ${position} down`,
  removeStep: (position) => `Remove step ${position}`,
  submit: 'Save',
  cancel: 'Cancel',
  errors: {
    required: 'Fill this in',
    tooLong: (max) => `At most ${max} characters`,
    wholeNumber: (min, max) => `A whole number from ${min} to ${max}`,
    offsetBeforePrevious: 'A step cannot come before the step above it',
  },
};

export const JOURNEY_FORM_LABELS: JourneyFormLabels = {
  type: 'Journey type',
  typePlaceholder: 'Choose a journey type',
  manager: 'Manager',
  managerDescription: 'The person who holds the conversations. Reminders go to them.',
  employeeEmail: 'Employee email',
  employeeName: 'Employee name',
  startDate: 'Start date',
  startDateDescription: 'The first working day. Every step is counted from here.',
  submit: 'Create journey',
  cancel: 'Cancel',
  errors: {
    required: 'Fill this in',
    tooLong: (max) => `At most ${max} characters`,
    invalidEmail: 'Enter an email address',
    alreadyRunning:
      'This employee already has a running journey with this manager. Stop it first.',
  },
};

export const JOURNEY_PLANNING_LABELS: JourneyPlanningLabels = {
  journeys: 'Journeys',
  steps: 'Steps',
  employee: 'Employee',
  manager: 'Manager',
  type: 'Type',
  startDate: 'Start date',
  status: 'Status',
  currentStep: 'Current step',
  allStepsPlanned: 'All steps planned',
  deadlineOn: (date) => `Deadline ${date}`,
  reachability: 'Reachable',
  position: '#',
  stepTitle: 'Step',
  targetDate: 'Target date',
  deadline: 'Deadline',
  stepStatus: 'Status',
  plannedDate: 'Planned on',
  notPlanned: 'Not planned',
  actions: (employeeName) => `Actions for ${employeeName}`,
  stop: 'Stop',
  delete: 'Delete',
  stepStatuses: {
    to_plan: 'To plan',
    action_required: 'Action required',
    planned: 'Planned',
    report_missing: 'Report missing',
    done: 'Done',
    late: 'Late',
  },
  journeyStatuses: {
    running: 'Running',
    done: 'Done',
    stopped: 'Stopped',
  },
};
